import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ChevronRightIcon, ShieldCheckIcon } from "lucide-react";
const HERO_IMAGE = "https://cdn.magicpatterns.com/patterns/generated-images/e6d69723-274c-4fc0-bf85-e0ece552d252.jpg";
export function Hero() {
  const reduce = useReducedMotion();
  const fade = (delay: number) => reduce ? {} : {
    initial: {
      opacity: 0,
      y: 12
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.28,
      delay,
      ease: [0.23, 1, 0.32, 1]
    }
  };
  return <section id="top" className="relative isolate flex min-h-[760px] items-end overflow-hidden bg-ink lg:min-h-[820px]" data-id="element-109" data-mp="x8b6zmndx72b">
      <img src={HERO_IMAGE} alt="" className="absolute inset-0 -z-10 h-full w-full object-cover object-[70%_center]" data-id="element-110" data-mp="ncgm0kvouzwd" />
      <div className="absolute inset-0 -z-10 bg-ink/70 lg:bg-ink/55" aria-hidden="true" data-id="element-111" data-mp="3d33gb2q0p1mv" />
      <div className="absolute inset-y-0 left-0 -z-10 hidden w-3/5 bg-ink/40 lg:block" aria-hidden="true" data-id="element-112" data-mp="381nu37c3sp2w" />

      <div className="mx-auto w-full max-w-7xl px-6 pb-20 pt-40 sm:px-8 lg:pb-28" data-id="element-113" data-mp="3j925dog4jqvj">
        <div className="max-w-3xl" data-id="element-114" data-mp="3o6khfnpfum7r">
          <motion.p {...fade(0)} className="text-[15px] font-medium text-white/85" data-id="element-115" data-mp="3o5j39ad4ljlt">
            Conseil en affaires publiques · Secteur des jeux
          </motion.p>
          <motion.h1 {...fade(0.05)} className="mt-5 font-display text-[44px] font-semibold leading-[1.05] tracking-tight text-white sm:text-6xl lg:text-[72px]" data-id="element-116" data-mp="3e84orgarj4w5">
            Faire entendre votre voix là où se décident les règles du jeu.
          </motion.h1>
          <motion.p {...fade(0.1)} className="mt-6 max-w-xl text-lg leading-relaxed text-white/80" data-id="element-117" data-mp="2qkwiow5ifrt2">
            J'accompagne les entreprises du jeu en ligne dans leurs relations avec les pouvoirs publics :
            anticiper la réglementation, structurer leurs positions et dialoguer avec les décideurs.
          </motion.p>

          <motion.div {...fade(0.15)} className="mt-10 flex flex-col gap-6 sm:flex-row sm:items-center sm:gap-10" data-id="element-118" data-mp="2ljz0ijki2xrk">
            <a href="#expertises" className="inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-md bg-white px-6 py-3.5 text-[15px] font-medium text-ink transition-colors duration-150 hover:bg-sand" data-id="element-119" data-mp="natatlbzb2pg">
              Découvrir l'accompagnement
              <ChevronRightIcon className="h-4 w-4" data-id="element-120" data-mp="1b1fel0eya0tn" />
            </a>
            <div className="flex items-center gap-3" data-id="element-121" data-mp="1ayjg9az6xa4o">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-white/30 text-white" data-id="element-122" data-mp="16346au4azydj">
                <ShieldCheckIcon className="h-5 w-5" data-id="element-123" data-mp="114suweyd1ft7" />
              </span>
              <p className="text-sm leading-snug text-white/85" data-id="element-124" data-mp="x0l50eg61tte">
                <span className="block font-semibold text-white" data-id="element-125" data-mp="3ltgnrsgieupe">Activité référencée HATVP</span>
                Répertoire des représentants d'intérêts
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}